import { NavigationService, NavigationServiceModule } from '@b2b/common/services/navigation/navigation.service';
import { TODO } from '@b2b/types/core/utils';
import angular, { IScope } from 'angular';

AccountController.$inject = ['$scope', 'NavigationService'];

function AccountController($scope: IScope & { account: TODO }, navigationService: NavigationService) {
  const ctrl = {
    init: function () {
      $scope.$emit('Application::contentTitleChange', { title: 'Account' });
    },
  };

  $scope.account = ctrl;
  ctrl.init();
}

export const AccountControllerModule = angular
  .module('acme.view.application.account.controllers', [NavigationServiceModule])
  .controller('AccountController', AccountController).name;
